exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speakers-page .nav-tabs {\n  border-bottom: 2px solid #aa4121;\n}\n.speakers-page .nav-tabs .nav-link {\n  padding: 0.9375rem 2.5rem;\n  font-size: 1rem;\n  color: #aa4121;\n  font-weight: bold;\n  border-bottom-color: #aa4121;\n  background-color: #f2f2f2;\n  text-transform: uppercase;\n}\n.speakers-page .nav-tabs .nav-link.active {\n  background-color: #aa4121;\n  border-color: #aa4121;\n  color: #fff;\n}\n.speakers-page .nav-tabs .nav-item a:not(.active):hover {\n  background: #ccc;\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};